"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsCreateRequestFiction = void 0;
exports.ProjectsCreateRequestFiction = {
    Fiction: "fiction",
    NonFiction: "non-fiction",
};
